import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgIf } from '@angular/common';

import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageModule } from 'primeng/message';
import { TooltipModule } from 'primeng/tooltip';

import { LoaderComponent } from '@common/loader/loader.component';

import { UserProfileService } from '@core/services/user.service';

import { OnboardingService } from '../../../onboarding/shared/services/onboarding.service';

interface WorkSpaceForm {
  workspace: FormControl;
}
@Component({
  selector: 'app-create-workspace-dialog',
  imports: [ButtonModule, LoaderComponent, ReactiveFormsModule, MessageModule, TooltipModule, NgIf],
  templateUrl: './create-workspace-dialog.component.html',
  styleUrl: './create-workspace-dialog.component.scss',
})
export class CreateWorkspaceDialogComponent {
  workSpaceForm!: FormGroup<WorkSpaceForm>;
  preventAbuse = false;
  errorMessage = '';
  constructor(
    private onboardingService: OnboardingService,
    private userService: UserProfileService,
    public ref: DynamicDialogRef
  ) {
    this.workSpaceForm = new FormGroup({
      workspace: new FormControl('', [
        Validators.required,
        Validators.maxLength(50),
        (control) => (control.value.trim() === '' ? { required: true } : null),
      ]),
    });
  }

  submit() {
    if (!this.workSpaceForm.valid) return;
    this.preventAbuse = true;
    this.onboardingService.createWorkspace(this.workSpaceForm.controls.workspace.value).subscribe({
      next: () => {
        this.preventAbuse = false;
        // update user
        this.userService.getUserDetails().subscribe();
        this.ref.close();
      },
      error: (err) => {
        this.errorMessage = err.error.message;
        this.preventAbuse = false;
      },
    });
  }
}
